export default __webpack_public_path__ + "e962434.png";